export const SET_RECENT_SEARCHED_GAME = 'SET_RECENT_SEARCHED_GAME';

export const SET_RECENT_LAUNCHED_GAME = 'SET_RECENT_LAUNCHED_GAME';
// Campaigns
export const SET_VIEWED_CAMPAIGNS = 'SET_VIEWED_CAMPAIGNS';

// Bonuses welcome message
export const SET_VIEWED_BONUSES_WELCOME = 'SET_VIEWED_BONUSES_WELCOME';
